import { render, staticRenderFns } from "./DynamicDataFields.vue?vue&type=template&id=cd1436d2&"
import script from "./DynamicDataFields.vue?vue&type=script&lang=ts&"
export * from "./DynamicDataFields.vue?vue&type=script&lang=ts&"
import style0 from "./DynamicDataFields.vue?vue&type=style&index=0&id=cd1436d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports